export default __webpack_public_path__ + "locales/ar-SA/SendInviteDialog.json?hash=37127c1af76cf214ad9417baac88aa9e";